var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSourceMultipleOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99504 8.48808L1.32522 5.63488L0.518555 6.26228L5.00002 9.74787L9.48149 6.26228L8.66985 5.6299L4.99504 8.48808ZM5.00002 7.22331L8.66487 4.37011L9.48149 3.73772L5.00002 0.252136L0.518555 3.73772L1.3302 4.37011L5.00002 7.22331ZM5.00002 1.51193L7.8582 3.73772L5.00002 5.96352L2.14184 3.73772L5.00002 1.51193Z",
    fill: "#64748D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSourceMultipleOutlined);
export default __webpack_public_path__ + "static/media/sourceMultipleOutlined.72afccf3f1eed82ee2c58a0cf737e52a.svg";
export { ForwardRef as ReactComponent };